import {
  DocumentReaderResponseType,
  GraphicFieldType,
} from '@regulaforensics/vp-frontend-document-components';
import { DocumentImageValue } from '../types';

const CANDIDATE_FIELDS = [GraphicFieldType.DOCUMENT_FRONT, GraphicFieldType.DOCUMENT_REAR];

const toBase64 = (imageValue?: DocumentImageValue): string | undefined =>
  imageValue?.value ?? imageValue?.originalValue;

export const extractSingleDocumentImage = (response: DocumentReaderResponseType): string | null => {
  const images = response.images;

  for (const field of CANDIDATE_FIELDS) {
    const value = toBase64(images?.getField(field)?.valueList?.[0]);
    if (value) {
      return value;
    }
  }

  return null;
};
